// Browser-native text-to-speech (SpeechSynthesis). Free, offline, no third-party service.
export function speechSupported() {
  return typeof window !== "undefined" && "speechSynthesis" in window;
}

function pickVoice() {
  const voices = window.speechSynthesis.getVoices() || [];
  const prefer = ["Google UK English Female", "Google US English", "Samantha", "Microsoft Aria", "Microsoft Jenny", "Daniel"];
  for (const name of prefer) {
    const v = voices.find((x) => x.name === name);
    if (v) return v;
  }
  return voices.find((v) => v.lang?.startsWith("en")) || voices[0] || null;
}

export function speak(text, { onStart, onEnd } = {}) {
  if (!speechSupported() || !text) { onEnd?.(); return; }
  window.speechSynthesis.cancel();
  const utter = new SpeechSynthesisUtterance(text);
  const voice = pickVoice();
  if (voice) utter.voice = voice;
  utter.rate = 1; utter.pitch = 1; utter.volume = 1;
  utter.onstart = () => onStart?.();
  utter.onend = () => onEnd?.();
  utter.onerror = () => onEnd?.();
  window.speechSynthesis.speak(utter);
}

export function stopSpeaking() {
  if (speechSupported()) window.speechSynthesis.cancel();
}

export function briefingToText(b) {
  if (!b) return "";
  const parts = [b.greeting];
  (b.decisions || []).forEach((d, i) => parts.push(`Decision ${i + 1}: ${d.title}. ${d.why}`));
  if (b.closing) parts.push(b.closing);
  return parts.filter(Boolean).join(". ");
}
